<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col col-lg-12 col-md-12 col-sm-12 col-12">
          <md-content class="ui-block md-elevation-10">
            <div class="ui-block-content">
              <div class="row">
                <slot />
                <div class="actions-styled mt-2">
                  <SButtonMaterial
                    class="mt-2 mr-4 btn-size"
                    buttonType="button"
                    color="primary"
                    textColor="white"
                    materialClass="dense"
                    data-cy="irSubmitForm"
                    :text="buttonName"
                    @button="$emit('button')"
                    :disabled="setDisabledBtn"
                  />
                  <SButtonMaterial
                    class="mt-2 btn-size"
                    buttonType="button"
                    color="danger"
                    textColor="white"
                    materialClass="dense"
                    data-cy="cancelForm"
                    text="Cancel"
                    @button="$emit('cancel')"
                  />
                </div>
              </div>
            </div>
          </md-content>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
export default {
  name: "ItemReviewForm",
  components: {
    SButtonMaterial,
  },
  computed: {
    buttonName() {
      if (this.$route.query.edit) return "Save";

      return "Post item";
    },
    setDisabledBtn() {
      return !this.$parent.filledFields;
    },
  },
};
</script>

<style lang="scss" scoped>
.ui-block {
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
  box-sizing: border-box !important;
  border-radius: 5px !important;
}
.actions-styled {
  width: 100%;
  display: flex;
  justify-content: center;
}
.btn-size {
  width: 115px;
}
</style>
